import Encoding from 'encoding-japanese'
import { jisdai3HasEncoded, jisdai4HasEncoded } from './sjis'

export const SPECIAL_CHARACTER = /[¥\\]|[%']|[,\t]|["]/

export const checkSpecialCharacter = (str = '') => {
  if (str) {
    if (SPECIAL_CHARACTER.test(str)) return true

    return !canEncodeSJIS(str)
  }

  return false
}

function canEncodeSJISChar(ch) {
  if (jisdai3HasEncoded.includes(ch) || jisdai4HasEncoded.includes(ch)) {
    return false
  }
  const unicodeArr = Encoding.stringToCode(ch)

  const sjis = Encoding.convert(unicodeArr, 'SJIS', 'UNICODE')
  const back = Encoding.convert(sjis, 'UNICODE', 'SJIS')

  return Encoding.codeToString(back) === ch
}

function canEncodeSJIS(str) {
  return [...str].every(canEncodeSJISChar)
}
